import { useEffect, useState } from 'react'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import XYZSource from 'ol/source/XYZ'
import View from 'ol/View'
import Zoom from 'ol/control/Zoom'
import useMapResize from '../../../../hooks/use-map-resize'
import { Extent, intersects } from 'ol/extent'
import { maxOrthoZoom } from '../../../../ol-styles'

export default function useMiniMap({
  container,
  mapboxToken,
  extent,
}: {
  container?: HTMLDivElement
  mapboxToken: string
  extent: Extent
}) {
  const [map, setMap] = useState<Map | undefined>(undefined)
  useMapResize(map, container)

  useEffect(() => {
    if (container) {
      const miniMap = new Map({
        target: container,
        controls: [new Zoom()],
        layers: [
          new TileLayer({
            source: new XYZSource({
              maxZoom: 17,
              tileSize: [512, 512],
              url:
                'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}?access_token=' +
                mapboxToken,
            }),
          }),
        ],
        view: new View({
          maxZoom: maxOrthoZoom,
        }),
      })

      setMap(miniMap)

      return () => {
        miniMap.setTarget(undefined)
        setMap(undefined)
      }
    }
    return undefined
  }, [mapboxToken, container])

  useEffect(() => {
    if (
      map &&
      (!map.getView().getCenter() ||
        !intersects(extent, map.getView().calculateExtent()))
    ) {
      map.getView().fit(extent, { padding: [40, 40, 40, 40] })
    }
  }, [map, extent])

  return map
}
